/**
 * OpenAPI
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AmtlicheBewertungDetailEntryMeta } from '../model/amtlicheBewertungDetailEntryMeta';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class AmtlichebewertungGbService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param grundstueckIds 
     * @param timestamp 
     * @param timepointId 
     * @param historisiert 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadAmtlicheBewertungSichtGrundstueck(grundstueckIds: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<AmtlicheBewertungDetailEntryMeta>>;
    public loadAmtlicheBewertungSichtGrundstueck(grundstueckIds: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<AmtlicheBewertungDetailEntryMeta>>>;
    public loadAmtlicheBewertungSichtGrundstueck(grundstueckIds: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<AmtlicheBewertungDetailEntryMeta>>>;
    public loadAmtlicheBewertungSichtGrundstueck(grundstueckIds: string, timestamp?: string, timepointId?: string, historisiert?: 'OHNE_HIST' | 'OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN' | 'MIT_HIST' | 'NUR_HIST', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (grundstueckIds === null || grundstueckIds === undefined) {
            throw new Error('Required parameter grundstueckIds was null or undefined when calling loadAmtlicheBewertungSichtGrundstueck.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (grundstueckIds !== undefined && grundstueckIds !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>grundstueckIds, 'grundstueckIds');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'timestamp');
        }
        if (timepointId !== undefined && timepointId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timepointId, 'timepointId');
        }
        if (historisiert !== undefined && historisiert !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>historisiert, 'historisiert');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/amtlichebewertung/gb/sichtGrundstueck`;
        return this.httpClient.request<Array<AmtlicheBewertungDetailEntryMeta>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
